<app-attendee-layout>
  <h1 *ngIf="title" class="sitemap__title">{{ title }}</h1>
  <app-router-tab-bar [tabBarLinks]="categories"> </app-router-tab-bar>
  <h2
    *ngIf="sitemapCategory && sitemapCategory.category_name"
    class="sitemap__title"
  >
    {{ sitemapCategory.category_name }}
  </h2>
  <div
    class="sitemap__category"
    *ngIf="sitemapCategory && sitemapCategory?.seo_sitemap_category"
  >
    <ul *ngFor="let link of sitemapCategory?.seo_sitemap_category">
      <li>
        <a [href]="link.href" class="sitemap__link">{{ link.rel }}</a>
      </li>
    </ul>
  </div>
</app-attendee-layout>
